import { useEffect, useState } from 'react';
import { Input, Label } from 'reactstrap';
import { api } from '../api/client.js';

/** Season + week pickers backed by whatever has actually been synced. */
export function WeekSelector({ season, week, onChange, disabled = false }) {
  const [seasons, setSeasons] = useState([]);
  const [weeks, setWeeks] = useState([]);

  useEffect(() => {
    api.seasons().then(setSeasons).catch(() => setSeasons([]));
  }, []);

  useEffect(() => {
    if (!season) return;
    api.weeks(season).then(setWeeks).catch(() => setWeeks([]));
  }, [season]);

  return (
    <div className="d-flex gap-3 align-items-end flex-wrap mb-3">
      <div>
        <Label for="season-select" className="mb-1 small text-muted">Season</Label>
        <Input
          id="season-select"
          type="select"
          value={season ?? ''}
          disabled={disabled || seasons.length === 0}
          onChange={(e) => onChange(Number(e.target.value), 1)}
        >
          {seasons.map((s) => (
            <option key={s.year} value={s.year}>{s.year}</option>
          ))}
        </Input>
      </div>

      <div>
        <Label for="week-select" className="mb-1 small text-muted">Week</Label>
        <Input
          id="week-select"
          type="select"
          value={week ?? ''}
          disabled={disabled || weeks.length === 0}
          onChange={(e) => onChange(season, Number(e.target.value))}
        >
          {weeks.map((w) => (
            <option key={w.number} value={w.number}>
              Week {w.number}{w.isComplete ? ' \u2713' : ''}
            </option>
          ))}
        </Input>
      </div>
    </div>
  );
}
